exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-item[data-v-3dc2c82f]{margin-bottom:0.10417rem}[data-v-3dc2c82f] .el-table thead.is-group th.el-table__cell{background-color:#EDF4FF}\n", ""]);

// exports
